import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { map } from 'rxjs/operators';
import { IDtoBudget } from 'app/shared/models/quote/budget.model';
import { IResult } from 'app/shared/models/result.model';
import { IDtoBudgetFilter } from 'app/shared/models/quote/budget-filter.model';
import { IDtoWorkingDay } from 'app/shared/models/position/dto-working-day.model';

@Injectable()
export class WorkingDayService {
    private quoteUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
            });
        }
    }
    public addWorkingDay(dto: IDtoWorkingDay): Observable<IResult> {
        const url =`${this.quoteUrl}api/WorkingDays/addWorkingDay`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateWorkingDay(dto: IDtoWorkingDay): Observable<IResult> {
        const url =`${this.quoteUrl}api/WorkingDays/updateWorkingDay`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getWorkingDays(): Observable<IResult> {
        const url = `${this.quoteUrl}api/WorkingDays/getWorkingDays`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogWorkingDays(payCompanyId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/WorkingDays/getCatalogWorkingDays?payCompanyId=${payCompanyId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
}